import {Injectable} from '@angular/core';
import { OnboardingApi } from 'src/app/api/onboarding.api';
import { ProcessUserOnboardingSessionRequest } from 'src/app/modals/edl-process-onboarding-request.model';

@Injectable()
export class OnboardingService {

    constructor(
        private onboardingApi: OnboardingApi,
    ) { }
    getOnboardingList = (type:number) => this.onboardingApi.getOnboardingList(type);

    uploadOnboardingList = (fileList: FileList) => this.onboardingApi.uploadOnboardingList(fileList);

    getOnboardingSessions = () => this.onboardingApi.getOnboardingSessions();

    getOnboardingSessionUserRequests = (sessionId: string, statusId: number, searchBy?:string, offset?:number, limit?:number) => 
        this.onboardingApi.getOnboardingSessionUserRequests(sessionId, statusId, searchBy, offset, limit);

    getOnboardingSessionDetails = (sessionId: string) => this.onboardingApi.getOnboardingSessionDetails(sessionId);

    processOnboardingSession = (session:ProcessUserOnboardingSessionRequest) => this.onboardingApi.processOnboardingSession(session);

    saveOnboardingSessions = (sessionId:string, sessionChanges:any[]) => this.onboardingApi.saveOnboardingSessions(sessionId, sessionChanges);
}